import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, shareReplay, tap } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  private astragate_token_url = `${environment.baseUrls.astragate_token}`;
  private astragate_callback_url = `${environment.baseUrls.astragate_callback}`;

  // private apiCredentials$?: Observable<any>;
  constructor(private http: HttpClient) {}

  getAPICredentials(): Observable<any> {
    return this.http.get(`${this.astragate_token_url}/api-access-details`);
  }

  generateCredentials(): Observable<any> {
    return this.http.post(
      `${this.astragate_token_url}/api-access-generate`,
      {},
    );
  }

  rotateSecret(clientId: any, clientSecret: any): Observable<any> {
    const body = { clientId, clientSecrete: clientSecret };
    return this.http.post(`${this.astragate_token_url}/new-secrete`, body);
  }

  getGenerateToken(clientId: any, clientSecret: any): Observable<any> {
    const body = { clientId, clientSecrete: clientSecret };
    return this.http.post(`${this.astragate_token_url}/auth-token`, body);
  }

  getCallbacks(): Observable<any> {
    return this.http.get(`${this.astragate_callback_url}/fetch`);
  }

  createCallback(callbackType: any, callbackUrl: any): Observable<any> {
    const body = { callbackUrl, callbackType };
    return this.http.post(`${this.astragate_callback_url}/register`, body);
  }

  deleteCallback(id: any): Observable<any> {
    return this.http.delete(`${this.astragate_callback_url}/delete/${id}`);
  }

  updateCallback(id: any, updated: any): Observable<any> {
    return this.http.put(
      `${this.astragate_callback_url}/update/${id}`,
      updated,
    );
  }

  getEncodedUTCDateClean(date: Date): string {
    if (!date) return '';
    const isoString = date.toISOString();
    const formattedDate = isoString.replace('T', ' ').replace(/\.\d+Z$/, '');
    return encodeURIComponent(formattedDate);
  }
}
